import {
  merge, concat, reject, isNil, propEq, find, isEmpty, insert, findIndex
} from 'ramda';
import {
  LOAD_SUCCESS,
  LOAD_REQUEST,
  LOAD_FAIL,
  DELETE_REQUEST,
  DELETE_FAIL,
  SUBMIT_FAIL,
  SUBMIT_SUCCESS,
  SUBMIT_REQUEST,
  UPDATE_FAIL,
  UPDATE_REQUEST,
  DELETE_SUCCESS,
  UPDATE_SUCCESS
} from 'src/store/actions/tvGraphActions';

const initialState = {
  list: [],
  config: {},
  fetching: false,
  errors: []
};


const addOrReplaceInList = (tvGraph, prop, list) => {
  const current = (find(propEq(prop, tvGraph[prop]), list)); // find relevant TV from list
  if (isEmpty(current) || isNil(current)) { // if the Tv does not exist ( was submit )
    return concat([tvGraph], list);
  }
  // if it exists, then add it to the list (on the same place it was before) and remove the old value.
  return insert(findIndex(propEq(prop, tvGraph[prop]), list), tvGraph, reject(propEq(prop, tvGraph[prop]), list));
};


const TvGraphReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_REQUEST:
      return merge(state, { fetching: true });
    case LOAD_FAIL:
      return merge(state, {
        fetching: false,
        errors: [action.error]
      });
    case LOAD_SUCCESS:
      return merge(state, {
        config: action.tvGraph.Configuration,
        list: action.tvGraph.GraphLines,
        fetching: false,
        errors: []
      });
    case SUBMIT_REQUEST:
      return merge(state, { fetching: true });
    case SUBMIT_FAIL:
      return merge(state, {
        fetching: false,
        errors: [action.error]
      });
    case SUBMIT_SUCCESS:
      return merge(state, {
        list: addOrReplaceInList(action.result, 'Id', state.list),
        fetching: false,
        errors: []
      });
    case UPDATE_REQUEST:
      return merge(state, { fetching: true });
    case UPDATE_FAIL:
      return merge(state, {
        fetching: false,
        errors: [action.error]
      });
    case UPDATE_SUCCESS:
      return merge(state, {
        list: addOrReplaceInList(action.result, 'Id', state.list),
        fetching: false,
        errors: []
      });
    case DELETE_REQUEST:
      return merge(state, { fetching: true });
    case DELETE_FAIL:
      return merge(state, {
        fetching: false,
        errors: [action.error]
      });
    case DELETE_SUCCESS:
      return merge(state, {
        errors: [],
        fetching: false,
        list: reject(propEq('Id', action.Id), state.list)
      });
    default:
      return state;
  }
};

export default TvGraphReducer;
